@if (isMobile()) {
  @if (snav.opened || isClosing()) {
    <div
      class="backdrop"
      [class.closing]="isClosing()"
      (click)="closeMenu()"
      (keyup.enter)="closeMenu()"
      tabindex="-1"
    ></div>
  }
  <div class="mobile-menu">
    <div class="toolbar-container" [class.opened]="snav.opened" [class.scrolled]="_isScrolled()">
      <button mat-icon-button (click)="toggleSnav()">
        <mat-icon svgIcon="menu-mobile"></mat-icon>
      </button>
      <img
        src="../../assets/images/wbi-logo-complete.svg"
        class="mobile-logo light-logo"
        alt="WonderBI"
      />
      <img
        src="../../assets/images/wbi-logo-mobile.svg"
        class="mobile-logo dark-logo"
        alt="WonderBI"
      />
    </div>
    <mat-sidenav-container
      class="mobile-sidenav-container"
      [style.marginTop.px]="isMobile() ? 56 : 0"
    >
      <mat-sidenav
        #snav
        [mode]="isMobile() ? 'over' : 'side'"
        class="mobile-sidenav"
        [fixedInViewport]="isMobile()"
        fixedTopGap="56"
      >
        <div class="user-info">
          <img src="../../assets/images/user-avatar.svg" alt="User" class="user-avatar" />
          <div class="user-details">
            <span class="user-name"
              >{{ sessionService.user()?.name }} {{ sessionService.user()?.surname }}</span
            >
          </div>
          <button class="logout-button" mat-icon-button (click)="logout()">
            <mat-icon svgIcon="logout"></mat-icon>
          </button>
        </div>
        @if (dashboards().length) {
          @for (dashboard of sortedDashboards(); track dashboard.id) {
            <a
              [routerLink]="['/dashboard', dashboard.id]"
              routerLinkActive="active"
              class="menu-link"
            >
              <mat-icon fontSet="hgi" [fontIcon]="iconClass(dashboard.icon)"></mat-icon>
              <span class="label-stack">
                <span class="label">{{ dashboard.name }}</span>
                @if (dashboard.status === 'draft') {
                  <wbi-dashboard-status-marker class="status-marker" [dashboard]="dashboard" />
                }
              </span>
            </a>
          }
          <mat-divider class="section-divider"></mat-divider>
        } @else if (dashboardPlaceholderOption(); as placeholder) {
          <a [routerLink]="placeholder.routerLink" routerLinkActive="active" class="menu-link">
            <mat-icon fontSet="hgi" [fontIcon]="placeholder.hgiIcon || 'hgi-dashboard-square-01'"></mat-icon>
            <span class="label" translate>$menu.{{ placeholder.name }}</span>
          </a>
          <mat-divider class="section-divider"></mat-divider>
        }
        @for (item of filteredMenuOptions(); track $index) {
          <a [routerLink]="item.routerLink" routerLinkActive="active" class="menu-link">
            @if (item.hgiIcon) {
              <mat-icon fontSet="hgi" [fontIcon]="item.hgiIcon"></mat-icon>
            } @else if (item.matIcon) {
              <span class="material-symbols-rounded">
                {{ item.matIcon }}
              </span>
            }
            <span class="label">
              {{ item.name }}
            </span>
          </a>
        }

        <a routerLink="/session/logout" class="menu-link">
          <span class="material-symbols-rounded"> logout </span>

          <span class="label" translate> $menu.logout </span>
        </a>
      </mat-sidenav>
    </mat-sidenav-container>
  </div>
} @else {
  <div class="side-bar-container" [class.shrink]="layoutService.drawerShrink()">
    <span class="logo">
      <wbi-menu-logo [shrink]="layoutService.drawerShrink() || false" />
    </span>
    <span
      class="options"
      [class.shrink]="layoutService.drawerShrink()"
      [class.expand]="!layoutService.drawerShrink()"
    >
      <span class="selector" #menuSelector></span>
      @if (sortedDashboards().length) {
        @for (dashboard of sortedDashboards(); track dashboard.id) {
          <a
            [routerLink]="['/dashboard', dashboard.id]"
            routerLinkActive="active"
            class="menu-link toggle-option"
          >
            <mat-icon fontSet="hgi" [fontIcon]="iconClass(dashboard.icon)"></mat-icon>
            <span class="label-stack">
              <span class="label" [class.visible]="!layoutService.drawerShrink()">
                {{ dashboard.name }}
              </span>
              @if (dashboard.status === 'draft') {
                <wbi-dashboard-status-marker class="status-marker" [dashboard]="dashboard" />
              }
            </span>
            @if (dashboard.status === 'draft') {
              <span
                class="draft-dot"
                role="img"
                [attr.aria-label]="'$dashboard-status.draft' | translateAsync"
              ></span>
            }
          </a>
          @if (!$last) {
            <mat-divider></mat-divider>
          }
        }
        <mat-divider class="section-divider"></mat-divider>
      } @else if (dashboardPlaceholderOption(); as placeholder) {
        <a
          [routerLink]="placeholder.routerLink"
          routerLinkActive="active"
          class="menu-link toggle-option"
        >
          <mat-icon fontSet="hgi" [fontIcon]="placeholder.hgiIcon || 'hgi-dashboard-square-01'"></mat-icon>
          <span class="label" [class.visible]="!layoutService.drawerShrink()" translate>
            $menu.{{ placeholder.name }}
          </span>
        </a>
        <mat-divider class="section-divider"></mat-divider>
      }
      @for (item of filteredMenuOptions(); track $index) {
        <a [routerLink]="item.routerLink" routerLinkActive="active" class="menu-link toggle-option">
          @if (item.hgiIcon) {
            <mat-icon fontSet="hgi" [fontIcon]="item.hgiIcon"></mat-icon>
          } @else if (item.matIcon) {
            <span class="material-symbols-rounded">
              {{ item.matIcon }}
            </span>
          }
          <span class="label" [class.visible]="!layoutService.drawerShrink()" translate>
            $menu.{{ item.name }}
          </span>
        </a>
        @if (!$last) {
          <mat-divider></mat-divider>
        }
      }

      <a routerLink="/session/logout" class="menu-link">
        <span class="material-symbols-rounded"> logout </span>

        <span class="label" [class.visible]="!layoutService.drawerShrink()" translate>
          $menu.logout
        </span>
      </a>
    </span>

    <span class="button-wrapper">
      <button mat-icon-button class="menu-button" (click)="layoutService.toggleDrawerShrink()">
        <mat-icon
          fontSet="material-symbols-rounded"
          [@rotate]="{
            value: layoutService.drawerShrink() ? 'start' : 'end',
            params: {
              startRotation: 0,
              startWithJiggle: -5,
              endRotation: 180,
              endWithJiggle: 185,
            },
          }"
        >
          chevron_right
        </mat-icon>
      </button>
    </span>
  </div>
}
